import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Contact from "./homepage/Contact";
import Header from "./homepage/Header";

export default function PressLayout() {
  return (
    <div id="press-page" data-testid="press-page">
      <Header type="press" scrollTop={200} />
      <Box
        id="press-page-content"
        data-testid="press-page-content"
        sx={{
          minHeight: "100vh",
          width: "100%",
          flex: true,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#eaeaea",
        }}
      >
        <Box sx={{ height: { xs: 120, lg: 200 } }} />
        <Container maxWidth="lg" sx={{ color: "black" }}>
          <Outlet />
        </Container>
      </Box>
      <Contact />
    </div>
  );
}
